// Query Counts Mapper
import { QueryCountsEntity } from "../../domain/entities/QueryCountsEntity";
import { QueryCountsDTO } from "../models/QueryCountsDTO";

export class QueryCountsMapper {
  static toDomain(dto: QueryCountsDTO): QueryCountsEntity {
    return {
      userId: dto.user_id,
      userName: dto.user_name,
      raisedByMe: {
        total: dto.raised_by_me.total,
        byStatus: {
          open: dto.raised_by_me.by_status.open,
          in_progress: dto.raised_by_me.by_status.in_progress,
          resolved: dto.raised_by_me.by_status.resolved,
          closed: dto.raised_by_me.by_status.closed,
        },
      },
      assignedToMe: {
        total: dto.assigned_to_me.total,
        byStatus: {
          open: dto.assigned_to_me.by_status.open,
          in_progress: dto.assigned_to_me.by_status.in_progress,
          resolved: dto.assigned_to_me.by_status.resolved,
          closed: dto.assigned_to_me.by_status.closed,
        },
      },
      totalQueriesInSystem: dto.total_queries_in_system,
    };
  }

  static toDTO(entity: QueryCountsEntity): QueryCountsDTO {
    return {
      user_id: entity.userId,
      user_name: entity.userName,
      raised_by_me: {
        total: entity.raisedByMe.total,
        by_status: {
          open: entity.raisedByMe.byStatus.open,
          in_progress: entity.raisedByMe.byStatus.in_progress,
          resolved: entity.raisedByMe.byStatus.resolved,
          closed: entity.raisedByMe.byStatus.closed,
        },
      },
      assigned_to_me: {
        total: entity.assignedToMe.total,
        by_status: {
          open: entity.assignedToMe.byStatus.open,
          in_progress: entity.assignedToMe.byStatus.in_progress,
          resolved: entity.assignedToMe.byStatus.resolved,
          closed: entity.assignedToMe.byStatus.closed,
        },
      },
      total_queries_in_system: entity.totalQueriesInSystem,
    };
  }
}

